import { gsap } from "gsap";
import Alpine from "alpinejs";
import sortBy from "lodash/sortBy";
const { wp } = window as any;

Alpine.data("postindex", (initialPosts) => ({
  posts: [],
  sortedBy: "",
  order: 'asc',
  hoverPostId: null,
  imgPosLeft: 0,
  imgPosTop: 0,

  init() {
    this.posts = initialPosts;
  },

  sortBy(by: string) {

    this.posts = sortBy(this.posts, item => item[by]?.toLowerCase());

    if (this.sortedBy === by) {
      this.order = this.order === 'asc' ? 'desc' : 'asc';
    }

    if (this.order === 'desc') {
      this.posts.reverse();
    }

    this.sortedBy = by;
  },

  updateImgPos($event) {
    this.imgPosLeft = $event.clientX;
    this.imgPosTop = $event.clientY;
  }
}));
